import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';
import { InformationBannerStyled } from '../../InformationBanner/InformationBanner.styles';

export const ReportDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const AccordionContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const ReportDetailsHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  border-radius: 8px;
  gap: 10px;

  ${InformationBannerStyled} {
    width: 100%;
  }
`;

export const ReportDetailsHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ReportDetailsHeaderText = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const TextBlock = styled.div`
  margin-bottom: 10px;
`;

export const EventEvidenceSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  width: 100%;
`;

export const InformationBannerContainer = styled.div`
  margin-bottom: 20px;
`;

export const EventDropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  /* Override dropdown chevron color to white */
  .uil-angle-down {
    color: ${(props) =>
      props.theme.atlas.semantic.color.type.inverse} !important;
  }
`;
export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin-bottom: 10px;
`;
